import { render, staticRenderFns } from "./po_service_detail.vue?vue&type=template&id=55dec1b3&scoped=true"
import script from "./po_service_detail.vue?vue&type=script&lang=js"
export * from "./po_service_detail.vue?vue&type=script&lang=js"
import style0 from "./po_service_detail.vue?vue&type=style&index=0&id=55dec1b3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dec1b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55dec1b3')) {
      api.createRecord('55dec1b3', component.options)
    } else {
      api.reload('55dec1b3', component.options)
    }
    module.hot.accept("./po_service_detail.vue?vue&type=template&id=55dec1b3&scoped=true", function () {
      api.rerender('55dec1b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/poManage/po_service_detail.vue"
export default component.exports